function redirectPopup() {
  const redirectPopupSection = document.querySelector('[data-redirect-popup]')

  if (!redirectPopupSection) { return }
  
  const redirectPopupTrigger = redirectPopupSection.querySelector('[data-redirect-popup-trigger]')
  const redirectPopupTextLink = redirectPopupSection.querySelector('[data-redirect-popup-text-link]')
  const redirectTimeout = parseInt(redirectPopupSection.dataset.redirectPopupTimeout, 10) * 1000
  const linkSearchString = redirectPopupSection.dataset.redirectPopupLink
  const applicableLinks = document.querySelectorAll(`a[href*="${linkSearchString}"]`)

  if (applicableLinks.length < 1) { return }

  applicableLinks.forEach((applicableLink) => {
    applicableLink.addEventListener('click', (event) => {
      event.preventDefault()

      redirectPopupTextLink.href = event.target.href
      redirectPopupTrigger.click()

      setTimeout(() => {
        window.location.href = event.target.href
      }, redirectTimeout)
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  redirectPopup()
})
